import { type ParsedAsset } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { useMemo } from 'react'
import { EditNotesInline } from '~/components/assets/EditNotesInline'
import { NotesDisplay } from '~/components/notes/NotesDisplay'

export function ProspectNotesDisplay({
  asset,
  className,
}: {
  asset: ParsedAsset
  className?: string
}) {
  const { t } = useTranslations('common')

  const relation = asset.relations?.[0]
  const isOwn = relation?.is_own ?? false
  const isProspect = relation?.relation_type === 'prospect'

  const prospectNotes = useMemo(() => {
    if (!isProspect) {
      return undefined
    }

    return relation?.data?.notes
  }, [relation, isProspect])

  return (
    <NotesDisplay
      notes={prospectNotes}
      canEdit={isOwn}
      className={className}
      editButton={
        isOwn ? (
          <EditNotesInline
            assetId={asset.id}
            currentNotes={prospectNotes ?? undefined}
            triggerVariant="link"
            triggerSize="sm"
            triggerLabel={t(($) => $.actions.edit)}
          />
        ) : undefined
      }
    />
  )
}
